import {React, useContext, useState, useEffect } from "react";
import UserContext from "../context/UserContext";
import {UserProvider} from "../context/UserContext";
import ThemeContext from "../context/ThemeContext";
import Profile from "../components/Profile";
import Sidebar from "../components/Sidebarstr";
import SternaSide from "../components/sidebars/sterna/SternaSide";
import { Outlet } from "react-router";
import { useApolloClient, gql } from '@apollo/client';
import TestQ from "../components/sidebars/sterna/TestQ";
import { Button } from 'primereact/button';

import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
        


const Home = () => {
  const {theme, setTheme} = useContext(ThemeContext);
  const {loginuser, setLoginUser} = useContext(ThemeContext);
  const { users, setUsers } = useContext(UserContext);
  const client = useApolloClient();
  const [value, setValue] = useState('');
  const [date, setDate] = useState(null);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const username = localStorage.getItem('loginuser');
        
        const { data } = await client.query({
          query: gql`
            query GetUserDetails($username: String!) {
              tbl_user_detail(where: { user_name: { _eq: $username } }) {
                user_name
                user_type
                firm_main_code
                firm_sub_code
                user_lang
              }
            }
          `,
          variables: { username },
        });

        const userDetails = data.tbl_user_detail[0];

        setUsers((prevUsers) => ({
          ...prevUsers,
          usernames: userDetails.user_name,
          usertype: userDetails.user_type,
          firmcode: userDetails.firm_main_code,
          subfirmcode: userDetails.firm_sub_code,
          userLang: userDetails.user_lang,
        }));
      } catch (error) {
        console.log("Error fetching user details:", error);
      }
    };

    fetchUserDetails();
  }, [client, setUsers]);

  useEffect(() => {
    setUsers((prevUsers) => ({
      ...prevUsers,
      placeSide: "1"
    }));
  }, []);

  return (
    <div>
      
      <Outlet />
      <div className="grid-flow-col flex mt-5 gap-4 ml-5 ">
    <div className="col-span-12 md:col-6 lg:col-3 ">
        <div className="surface-0 shadow-2 p-3 rounded-md border-solid border outline-1 border-indigo-600">
            <div className="flex justify-content-between mb-3 ">
                <div>
                    <span className="block text-500 font-medium mb-3">New Custommer</span>
                    <div className="text-900 font-medium text-xl">152</div>
                </div>
                <div className="flex align-items-center justify-content-center ml-10 bg-blue-100 border-round" style={{ width: '2.5rem', height: '2.5rem' }}>
                    <i className="pi pi-shopping-cart text-blue-500 text-xl"></i>
                </div>
            </div>
            <span className="text-green-500 font-medium">24 </span>
            <span className="text-500">Updated</span>
        </div>
    </div>
    <div className="col-12 md:col-6 lg:col-3">
        <div className="ssurface-0 shadow-2 p-3 rounded-md border-solid border outline-1 border-indigo-600">
            <div className="flex justify-content-between mb-3">
                <div>
                    <span className="block text-500 font-medium mb-3">Today Call</span>
                    <div className="text-900 font-medium text-xl">3</div>
                </div>
                <div className="flex align-items-center justify-content-center  ml-10 bg-orange-100 border-round" style={{ width: '2.5rem', height: '2.5rem' }}>
                    <i className="pi pi-map-marker text-orange-500 text-xl"></i>
                </div>
            </div>
            <span className="text-green-500 font-medium">15 </span>
            <span className="text-500">Next Week Call</span>
        </div>
    </div>
    <div className="col-12 md:col-6 lg:col-3">
        <div className="surface-0 shadow-2 p-3 rounded-md border-solid border outline-1 border-indigo-600 w-44">
            <div className="flex justify-content-between mb-3">
                <div>
                    <span className="block text-500 font-medium mb-3">Enquire</span>
                    <div className="text-900 font-medium text-xl">7</div>
                </div>
                <div className="flex align-items-center justify-content-center  ml-14 bg-cyan-100 border-round" style={{ width: '2.5rem', height: '2.5rem' }}>
                    <i className="pi pi-inbox text-cyan-500 text-xl"></i>
                </div>
            </div>
            <span className="text-green-500 font-medium">20  </span>
            <span className="text-500">Last Week</span>
        </div>
    </div>
    <div className="col-12 md:col-6 lg:col-3">
        <div className="surface-0 shadow-2 p-3 rounded-md border-solid border outline-1 border-indigo-600">
            <div className="flex justify-content-between mb-3">
                <div>
                    <span className="block text-500 font-medium mb-3">Comments</span>
                    <div className="text-900 font-medium text-xl">152 Unread</div>
                </div>
                <div className="flex align-items-center justify-content-center  ml-6 bg-purple-100 border-round" style={{ width: '2.5rem', height: '2.5rem' }}>
                    <i className="pi pi-comment text-purple-500 text-xl"></i>
                </div>
            </div>
            <span className="text-green-500 font-medium">85 </span>
            <span className="text-500">responded</span>
        </div>
    </div>
   

      




</div>
<SternaSide />

<Profile />
</div> 

)
}; 

export default Home;

